var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronThinLeft = function SvgChevronThinLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.226 27.469c.429.435.429 1.134 0 1.566s-1.122.434-1.55 0L8.148 16.382a1.114 1.114 0 0 1 0-1.566L20.676 2.163a1.09 1.09 0 0 1 1.55 0 1.114 1.114 0 0 1 0 1.566L10.8 15.599l11.426 11.869z"
  })));
};
export default SvgChevronThinLeft;